import React, { useState, useEffect, useCallback } from 'react';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { logout as logoutApi } from '../../api/auth';
import useIdleTimeout from '../../hooks/useIdleTimeout';

const IDLE_TIMEOUT_MS   = 60 * 60 * 1000; // 1 saat hareketsizlik
const IDLE_WARNING_MS   = 60 * 1000;      // suresi dolmadan 1 dk once uyar

// Tum portallarda (personel, veli, stajyer) gecerli - App.js icinde
// BrowserRouter'in hemen altina, Routes ile kardes olarak monte edilir ki
// useNavigate kullanabilsin. isAuthenticated degilse hicbir sey yapmaz.
const IdleSessionGuard = () => {
  const { isAuthenticated, logout: storeLogout } = useAuthStore();
  const navigate = useNavigate();
  const [warningOpen, setWarningOpen] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(60);

  const handleTimeout = useCallback(async () => {
    setWarningOpen(false);
    try { await logoutApi(); } catch { /* token zaten gecersiz olabilir */ }
    storeLogout();
    navigate('/login');
  }, [storeLogout, navigate]);

  const handleWarn = useCallback((remainingMs) => {
    setSecondsLeft(Math.max(1, Math.round((remainingMs ?? IDLE_WARNING_MS) / 1000)));
    setWarningOpen(true);
  }, []);

  // Baska bir sekmede aktivite oldugunda (veya kullanici burada "Devam Et"e
  // bastiginda) sayac sifirlaniyor - acik uyari varsa kapat.
  const handleReset = useCallback(() => setWarningOpen(false), []);

  const { reset } = useIdleTimeout({
    enabled:   isAuthenticated,
    timeoutMs: IDLE_TIMEOUT_MS,
    warningMs: IDLE_WARNING_MS,
    onWarn:    handleWarn,
    onTimeout: handleTimeout,
    onReset:   handleReset,
  });

  useEffect(() => {
    if (!warningOpen) return undefined;
    const interval = setInterval(() => {
      setSecondsLeft(s => Math.max(0, s - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [warningOpen]);

  if (!isAuthenticated) return null;

  return (
    <Modal
      open={warningOpen}
      title="Oturumunuz kapanmak üzere"
      onOk={reset}
      onCancel={reset}
      okText="Devam Et"
      cancelButtonProps={{ style: { display: 'none' } }}
      closable={false}
      maskClosable={false}
      centered
    >
      <p>
        Uzun süredir hareketsizsiniz. Güvenlik nedeniyle <strong>{secondsLeft} saniye</strong> içinde
        otomatik olarak oturumunuz kapatılacak. Devam etmek için "Devam Et"e tıklayın.
      </p>
    </Modal>
  );
};

export default IdleSessionGuard;
